import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Breadcrumbs from '@components/Breadcrumbs/Breadcrumbs';
import Button from '@components/Button/Button';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import PagesAccordion from '@features/pages/components/PagesAccordion/PagesAccordion';
import ReturnsLandingSection from '@features/returns/components/ReturnsLandingSection/ReturnsLandingSection';
import { getReturnableOrderPositions } from '@features/returns/utils/getReturnableOrderPositions';
import { TReturnsContent } from '@features/returns/utils/extractCmsBlocks';
import { IAccordion } from '@features/pages/typescript';
import { TUserOrderType } from '@features/userPanel/typescript';
import { ASSEMBLY_SERVICE_VAT_8_ID } from '@features/cart/const';
import theme from '@styles/theme';
import styles from '@features/returns/components/ReturnsPageContent/ReturnsPageContent.styles';
import ProductReturnForm from '@features/userPanel/components/ProductReturn/ProductReturnForm';
type PropsType = {
  headerContent?: TReturnsContent | null;
  accordionBlock?: IAccordion | null;
};
const ReturnsPageContent = ({
  headerContent,
  accordionBlock
}: PropsType) => {
  const {
    t
  } = useTranslation(['user', 'common']);
  const [selectedOrder, setSelectedOrder] = useState<TUserOrderType | null>(null);
  const breadcrumbSteps = [{
    name: t('common:home'),
    href: '/',
    id: 0
  }, {
    name: t('returnsPage.breadcrumb'),
    href: '/zwroty',
    id: 1
  }];
  const handleBackToLookup = () => {
    setSelectedOrder(null);
  };
  const isStorAssemblyAvailable = selectedOrder?.positions.filter(position => position.name === 'service.assembly').some(position => position.serviceId === ASSEMBLY_SERVICE_VAT_8_ID) ?? false;
  return <div sx={styles.page}>
      <div sx={styles.breadcrumbContainer}>
        <Breadcrumbs steps={breadcrumbSteps} />
      </div>

      {selectedOrder ? <div sx={styles.formView}>
          <div sx={styles.formHeader}>
            <Button variant="iconOnly" onClick={handleBackToLookup} cy="ReturnPageBackButton">
              <Icon icon="ArrowBack" size="24px" color={theme.rawColors.darkGrey700} />
            </Button>
            <Heading h={2} headingType={3} align="left" addSx={styles.formHeaderTitle}>
              {t('orders.return.formHeading', {
            orderNumber: selectedOrder.number
          })}
            </Heading>
          </div>
          <div sx={styles.formCard}>
            <ProductReturnForm products={getReturnableOrderPositions(selectedOrder)} orderData={{
          orderId: selectedOrder.orderId,
          orderNumber: selectedOrder.number,
          customerId: selectedOrder.customerId
        }} isStorAssemblyAvailable={isStorAssemblyAvailable} onBack={handleBackToLookup} />
          </div>
        </div> : <ReturnsLandingSection headerContent={headerContent} onOrderFound={setSelectedOrder} />}

      {!selectedOrder && accordionBlock && <section sx={styles.faqSection}>
          <div sx={styles.faqContainer}>
            <PagesAccordion block={accordionBlock} isFirst />
          </div>
        </section>}
    </div>;
};
export default ReturnsPageContent;